// Normalize string to remove accents and diacritics
// Based on https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Note: If we want to have more advanced search capabilities we can use a library for fuzzy search instead
export const normalizeCharacters = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const capitalizeWord = (str) => {
    if (typeof str === 'string' && str.length >= 1) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    } else {
        return '';
    }
};
